<template>
  <header class="header">
    <div class="header-container">
      <!-- Logo -->
      <router-link to="/" class="logo" @click="closeMenu">
        <img src="/logo-4n.png" alt="Fourin" />
      </router-link>

      <!-- NAVEGACIÓN DESKTOP -->
      <nav class="nav-links desktop-nav">
        <router-link to="/" class="nav-link" :class="{ active: $route.path === '/' }">Inicio</router-link>
        <router-link to="/precios" class="nav-link" :class="{ active: $route.path === '/precios' }">Precios</router-link>
        <router-link to="/blog" class="nav-link" :class="{ active: $route.path.startsWith('/blog') }">Blog</router-link>
        <router-link to="/ebook" class="nav-link" :class="{ active: $route.path === '/ebook' }">Ebook</router-link>
        <router-link to="/about" class="nav-link" :class="{ active: $route.path === '/about' }">¿Quiénes somos?</router-link>
      </nav>

      <!-- ACCIONES DERECHA -->
      <div class="header-right">
        <router-link to="/contact" class="contact-link desktop-link">Contáctanos</router-link>
        <a href="https://app.fourin.co/" class="login-button desktop-link">Inicia sesión</a>

        <!-- HAMBURGUESA (MÓVIL) -->
        <button class="hamburger" @click="toggleMenu" aria-label="Abrir menú" :class="{ 'is-active': isMenuOpen }">
          <span class="hamburger-box"><span class="hamburger-inner"></span></span>
        </button>
      </div>
    </div>

    <!-- MENÚ MÓVIL -->
    <transition name="slide-down">
      <div v-if="isMenuOpen" class="mobile-menu">
        <nav class="mobile-nav-links">
          <router-link to="/" class="mobile-nav-link" @click="closeMenu">Inicio</router-link>
          <router-link to="/blog" class="mobile-nav-link" @click="closeMenu">Blog</router-link>
          <router-link to="/precios" class="mobile-nav-link" @click="closeMenu">Precios</router-link>
          <router-link to="/ebook" class="mobile-nav-link" @click="closeMenu">Ebook</router-link>
          <router-link to="/about" class="mobile-nav-link" @click="closeMenu">¿Quiénes somos?</router-link>
          <router-link to="/contact" class="mobile-nav-link" @click="closeMenu">Contáctanos</router-link>
        </nav>
        <div class="mobile-actions">
          <a href="https://app.fourin.co/" class="mobile-login-button" @click="closeMenu">Inicia sesión</a>
        </div>
      </div>
    </transition>
  </header>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const isMenuOpen = ref(false)

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
  document.body.style.overflow = isMenuOpen.value ? 'hidden' : ''
}

const closeMenu = () => {
  isMenuOpen.value = false
  document.body.style.overflow = ''
}
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, .82);
  backdrop-filter: blur(14px);
  border-bottom: 1px solid #EDF1F6;
}

.header-container {
  max-width: 1340px;
  margin: 0 auto;
  padding: 13px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo img {
  height: 38px;
  width: auto;
  display: block;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 26px;
}

.nav-link {
  text-decoration: none;
  color: #46566B;
  font-size: 15px;
  font-weight: 600;
  transition: color 0.2s ease;
}

.nav-link:hover {
  color: #129bef;
}

.nav-link.active {
  color: #129bef;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.contact-link {
  text-decoration: none;
  color: #46566B;
  font-size: 15px;
  font-weight: 600;
  transition: color 0.2s ease;
}

.contact-link:hover {
  color: #129bef;
}

.login-button {
  background: #129bef;
  color: #fff;
  text-decoration: none;
  font-weight: 700;
  font-size: 15px;
  padding: 11px 22px;
  border-radius: 999px;
  transition: background-color 0.2s ease;
}

.login-button:hover {
  background: #0c82ce;
}

/* HAMBURGUESA */
.hamburger {
  display: none;
  padding: 0;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  margin: 0;
  z-index: 1010;
}

.hamburger-box {
  width: 24px;
  height: 24px;
  display: inline-block;
  position: relative;
}

.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -2px;
}

.hamburger-inner,
.hamburger-inner::before,
.hamburger-inner::after {
  width: 24px;
  height: 2px;
  background-color: #0F1B2E;
  border-radius: 4px;
  position: absolute;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

.hamburger-inner::before,
.hamburger-inner::after {
  content: '';
  display: block;
}

.hamburger-inner::before {
  top: -8px;
}

.hamburger-inner::after {
  bottom: -8px;
}

.hamburger.is-active .hamburger-inner {
  transform: rotate(45deg);
}

.hamburger.is-active .hamburger-inner::before {
  top: 0;
  opacity: 0;
}

.hamburger.is-active .hamburger-inner::after {
  bottom: 0;
  transform: rotate(-90deg);
}

/* MENÚ MÓVIL */
.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: white;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  padding: 20px 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mobile-nav-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 20px;
  width: 100%;
}

.mobile-nav-link {
  text-decoration: none;
  color: #0F1B2E;
  font-size: 18px;
  font-weight: 600;
  padding: 10px 0;
  border-bottom: 1px solid #EDF1F6;
}

.mobile-actions {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 20px;
  gap: 10px;
}

.mobile-login-button {
  text-align: center;
  background: #129bef;
  color: white;
  text-decoration: none;
  padding: 12px;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 700;
}

/* TRANSITIONS */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease-in-out;
}

.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

/* RESPONSIVE */
@media (max-width: 1024px) {
  .desktop-nav,
  .desktop-link {
    display: none;
  }

  .hamburger {
    display: block;
  }
}

@media (max-width: 768px) {
  .header-container {
    padding: 12px 18px;
  }

  .logo img {
    height: 32px;
  }
}
</style>
